import { useFlags, useFlagsmithLoading } from '@flagsmith/flagsmith/react';

export const useFeatureFlagValue = (flagName: string) => {
  const flags = useFlags([flagName]) || {};
  const featureFlag = flags[flagName];
  const flagsmithState = useFlagsmithLoading();
  const isLoading = flagsmithState?.isLoading || flagsmithState?.isFetching;

  if (isLoading || !featureFlag) {
    return null;
  }

  return featureFlag.enabled ? featureFlag.value : null;
};

export const useFeatureFlag = (flagName: string) => {
  return Boolean(useFeatureFlagValue(flagName));
};
